import settings from '@/settings'

const multiMethods = (headers, data) => {
  let url = `${settings.apetrusApi}/pedidos/`

  if (data.id) {
    url += `${data.id}/`
  }

  const parameter = {
    method: data.method,
    mode: 'cors',
    headers: headers
  }

  if (data.parametros) {
    Object.keys(data.parametros).forEach((filter) => {
      url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${filter}=${data.parametros[filter]}`
    })
  }

  if (data.method === 'GET') {
    parameter.cache = 'default'
  } else if (data.body) parameter.body = JSON.stringify(data.body)

  return fetch(url, parameter)
}

const mudarStatusPedido = (headers, data) => {
  return fetch(`${settings.apetrusApi}/pedidos/${data.id}/mudar-status/`, {
    method: 'PUT',
    headers: headers,
    body: JSON.stringify(data.body),
    mode: 'cors'
  })
}

export default {
  multiMethods,
  mudarStatusPedido
}
